import { LicenseInfo } from '@mui/x-license';
const licenseKey = '973425b63aaa040dd062fbfab76187cfTz0xMjE5ODMsRT0xNzk1MDQ2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
LicenseInfo.setLicenseKey(licenseKey);
